import React from "react";

import { XIcon } from "@phosphor-icons/react";

import { useTranslation } from "react-i18next";
import { useRootElement } from "../../context";

import * as styles from "./styles";

export function Header() {
  const { t } = useTranslation("localContent");
  const { onToggleIsOpen } = useRootElement();

  return (
    <div className={styles.container}>
      <h2 data-testid="commute-calculator-title" className={styles.title}>
        {t("commute.cta")}
      </h2>

      <button
        onClick={onToggleIsOpen}
        data-testid="commute-calculator-close-button"
      >
        <XIcon weight="bold" className={styles.icon} />
      </button>
    </div>
  );
}
